import React from "react";
import AppBar from "@material-ui/core/AppBar";
import Typography from "@material-ui/core/Typography";

import _ from "lodash";
import TrajectorySelector from "../components/TrajectorySelector";
import TrajectoryViewer from "../components/TrajectoryViewer";

function Content(props) {
  const { classes, client, trajectories, addSavedState } = props;
  const [trajectorySelection, setTrajectorySelection] = React.useState(() => {
    try {
      return JSON.parse(localStorage.getItem("trajectorySelection"));
    } catch (e) {
      return null;
    }
  });
  const [viewingTrajectory, setViewingTrajectory] = React.useState(
    trajectorySelection
  );

  const findTrajectory = (phi, chi, version) => {
    return _.find(trajectories, traj => {
      return traj.PHI === phi && traj.CHI === chi && traj.version === version;
    });
  };

  const findAndSetTrajectory = (phi, chi, version) => {
    setTrajectorySelection(findTrajectory(phi, chi, version));
    localStorage.setItem(
      "trajectorySelection",
      JSON.stringify(trajectorySelection)
    );
  };

  const queryTrajectory = () => {
    setViewingTrajectory(trajectorySelection);
  };

  return (
    <React.Fragment>
      <AppBar
        className={classes.searchBar}
        position="static"
        color="default"
        elevation={0}
      >
        <TrajectorySelector
          classes={classes}
          trajectories={trajectories}
          findAndSetTrajectory={findAndSetTrajectory}
          trajectorySelection={trajectorySelection}
          queryTrajectory={queryTrajectory}
        />
      </AppBar>
      <div className={classes.contentWrapper}>
        {viewingTrajectory ? (
          <TrajectoryViewer
            classes={classes}
            client={client}
            trajectory={viewingTrajectory}
            addSavedState={addSavedState}
          />
        ) : (
          <Typography color="textSecondary" align="center">
            Select a Trajectory
          </Typography>
        )}
      </div>
    </React.Fragment>
  );
}

export default Content;



// WEBPACK FOOTER //
// ./src/sections/data/subsections/Browser.js